import SectionBadge from "@/components/site/SectionBadge";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

// Long opportunity statements read better trimmed to their lead sentence.
const clamp = (t, max = 150) => {
  if (!t || t.length <= max) return t;
  const cut = t.slice(0, max);
  const end = Math.max(cut.lastIndexOf(". "), cut.lastIndexOf(";"), cut.lastIndexOf(","));
  return (end > 60 ? cut.slice(0, end) : cut).replace(/[,;\s]+$/, "") + ".";
};

/**
 * Business outcomes strip — areas of commercial impact (not guaranteed results).
 */
export default function OutcomeStrip({
  testid,
  badge = "Business Outcomes",
  headline,
  items,
  note,
}) {
  // Pick a column count that leaves no empty bordered cells.
  const cols = items.length % 3 === 0 || items.length % 2 !== 0 ? "md:grid-cols-3" : "md:grid-cols-2";
  return (
    <section data-testid={testid} className="py-16 md:py-20 bg-[#050505] text-white">
      <div className={GRID}>
        <SectionBadge label={badge} tone="light" />
        <h2 className="font-serif-display text-3xl sm:text-4xl mt-6 leading-[1.1] max-w-2xl">
          {headline}
        </h2>
        <ul className={`mt-10 grid grid-cols-1 sm:grid-cols-2 ${cols} gap-px bg-white/15 border border-white/15 reveal stagger-reveal`}>
          {items.map((o, i) => (
            <li
              key={o}
              data-testid={`${testid}-item-${i}`}
              className="bg-[#050505] p-6 md:p-8 flex gap-5"
            >
              <div className="text-[11px] font-semibold tracking-[0.28em] text-white/40 shrink-0 pt-1">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="font-serif-display text-lg md:text-xl leading-snug text-white">
                {clamp(o)}
              </div>
            </li>
          ))}
        </ul>
        {note && (
          <p className="mt-6 text-xs sm:text-[13px] text-white/50 leading-relaxed max-w-3xl">
            {note}
          </p>
        )}
      </div>
    </section>
  );
}
